import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        callingAPI: false,
        searching: '',
        serverURI: 'http://10.110.1.136:8080',
        user: null,
        token: null,
        userInfo: {
            messages: [],
            notifications: [],
            tasks: []
        },
        listGoodsFilter: null,
        isFooterShow: true,
        isIndexSelectShow: false,
        switchLanguage: 'zh-TW',
        borderStyle: '',
        developerType: '',
        registeredDetail: '',
        ulClassFlag: '',
        isSideBarShow: '',
        isSearchProject: false,
        isFrontHeaderShow: false,
        // 后台header state
        isFlagSpanClass: '',
        isFlagLiClass: '',
        secondNavItem: [],
        iconNavHeader: [],
        // 专案分析的appid
        appId: '',
        // 状态
        thirdNavigationState: null,
        thirdNavigationType: null,
        thirdNavigationIdentify: '',
        thirdNavigationSearch: '',
        orderSumAll: '',
        // 专案清单
        MyProjectsAddState: '',
        // 专案版本id
        versionHistoryId: '',
        // 我的专案搜索id
        myProjectsSearchId: {},
        pickerDom: null,
        globalSelectControlState: false
    },
    mutations: {
        globalSelectControlFn (state, { key, status }) {
            if (status === state.globalSelectControlState) {
                state.globalSelectControlState = null
            } else {
                state[key] = status
            }
        }
    },
    actions: {

    }
})
